"use strict";
var lodash_1 = require("lodash");
var gpml_utilities_1 = require("./gpml-utilities");
var INTERACTION_DEFAULTS = {
    attributes: {
        Color: {
            name: 'Color',
            value: '000000'
        },
        ConnectorType: {
            name: 'ConnectorType',
            value: 'Straight'
        },
        FillColor: {
            name: 'FillColor',
            value: 'Transparent'
        },
        LineThickness: {
            name: 'LineThickness',
            value: 1
        }
    }
};
var biopaxPhysicalEntityTypes = [
    'Protein',
    'Dna',
    'Rna',
    'SmallMolecule',
    'Gene',
    'PhysicalEntity',
    'Complex'
];
var biopaxPhysicalEntityTypesPrefixed = biopaxPhysicalEntityTypes.map(function (x) { return 'biopax:' + x; });
var biopaxNodeTypes = biopaxPhysicalEntityTypes.concat([
    'PublicationXref',
    'UnificationXref',
    'RelationshipXref',
    'ProteinReference',
    'DnaReference',
    'RnaReference',
    'SmallMoleculeReference',
    'Pathway'
]);
var biopaxNodeTypesPrefixed = biopaxNodeTypes.map(function (x) { return 'biopax:' + x; });
var markerNameToIdentifierMappings = {
    // NOTE we are inferring more specific type based on participant type(s)
    // as well as any controls on the interaction
    Arrow: {
        biopax: {
            name: 'Interaction'
        },
        sbo: ['SBO:0000167', 'SBO:0000393', 'SBO:0000394'],
        wp: 'DirectedInteraction',
    },
    TBar: {
        biopax: {
            name: 'Control',
            controlType: 'INHIBITION'
        },
        sbo: ['SBO:0000169'],
        wp: 'Inhibition',
    },
    'mim-gap': {
        biopax: {
            name: 'Interaction'
        }
    },
    'mim-branching-right': {
        biopax: {
            name: 'Interaction'
        }
    },
    'mim-branching-left': {
        biopax: {
            name: 'Interaction'
        }
    },
    'mim-inhibition': {
        biopax: {
            name: 'Control',
            controlType: 'INHIBITION'
        },
        sbo: ['SBO:0000169'],
        wp: 'Inhibition',
    },
    'mim-conversion': {
        biopax: {
            name: 'Conversion'
        },
        sbo: ['SBO:0000182'],
        wp: 'Conversion',
    },
    'mim-necessary-stimulation': {
        biopax: {
            name: 'Control',
            controlType: 'ACTIVATION' // does anyone object?
        },
        sbo: ['SBO:0000171'],
        wp: 'Stimulation',
    },
    'mim-binding': {
        biopax: {
            // ComplexAssembly is generally too highly specified
            // to accurately model the data in our average pathway,
            // but in some cases, it could be a more appropriate
            // mapping.
            name: 'MolecularInteraction'
        },
        sbo: ['SBO:0000177'],
        wp: 'Binding',
    },
    'mim-stimulation': {
        biopax: {
            name: 'Control',
            controlType: 'ACTIVATION' // does anyone object?
        },
        sbo: ['SBO:0000170'],
        wp: 'Stimulation',
    },
    'mim-modification': {
        biopax: {
            name: 'BiochemicalReaction'
        },
        sbo: ['SBO:0000210'],
        wp: 'DirectedInteraction',
    },
    'mim-catalysis': {
        biopax: {
            name: 'Catalysis'
        },
        sbo: ['SBO:0000172'],
        wp: 'Catalysis',
    },
    'mim-cleavage': {
        biopax: {
            name: 'Degradation'
        },
        sbo: ['SBO:0000178'],
        wp: 'DirectedInteraction',
    },
    'mim-covalent-bond': {
        biopax: {
            name: 'BiochemicalReaction'
        },
        sbo: ['SBO:0000210'],
        wp: 'DirectedInteraction',
    },
    'mim-transcription-translation': {
        biopax: {
            name: 'GeneticInteraction'
        },
        sbo: ['SBO:0000183', 'SBO:0000184']
    },
    'none': {
        biopax: {
            name: 'Interaction'
        },
        sbo: ['SBO:0000374'],
        wp: 'TranscriptionTranslation',
    }
};
function applyDefaults(gpmlElement, defaults) {
    gpmlElement = gpml_utilities_1.applyDefaults(gpmlElement, [INTERACTION_DEFAULTS, defaults]);
    return gpmlElement;
}
exports.applyDefaults = applyDefaults;
;
function convertConversionToGenericInteraction(interaction) {
    console.warn('This Conversion fails BioPAX validator:)');
    console.warn(interaction);
    interaction.type = ['Interaction'];
    interaction.participant = [interaction.left, interaction.right];
    delete interaction.left;
    delete interaction.right;
    delete interaction.conversionDirection;
    delete interaction.sboInteractionType;
    delete interaction.wpInteractionType;
    return interaction;
}
function convertCatalysisToGenericInteraction(interaction) {
    console.warn('This Catalysis fails BioPAX validator:)');
    console.warn(interaction);
    interaction.type = ['Interaction'];
    interaction.participant = [interaction.controlled, interaction.controller];
    delete interaction.controlled;
    delete interaction.controller;
    delete interaction.interactionType;
    return interaction;
}
function postProcess(data, interaction) {
    var points;
    var targetId;
    var targetNode;
    var sourceId;
    var sourceNode;
    var marker;
    if (interaction.markerStart) {
        marker = interaction.markerStart;
        // sometimes the graphical terminology (startMarker, endMarker) won't line up
        // with the graph terminology.
        sourceId = interaction.points[interaction.points.length - 1].isAttachedTo;
        targetId = interaction.points[0].isAttachedTo;
    }
    else if (interaction.markerEnd) {
        marker = interaction.markerEnd;
        sourceId = interaction.points[0].isAttachedTo;
        targetId = interaction.points[interaction.points.length - 1].isAttachedTo;
    }
    else {
        marker = 'none';
        sourceId = interaction.points[0].isAttachedTo;
        targetId = interaction.points[interaction.points.length - 1].isAttachedTo;
    }
    // this can be overridden with a more specific term below
    var elementMap = data.elementMap;
    if (!sourceId || !targetId) {
        console.warn('Unconnected Interaction(s) present in this pathway.');
        return interaction;
    }
    sourceNode = elementMap[sourceId];
    targetNode = elementMap[targetId];
    if (marker === 'Arrow') {
        var sourceIsEdge = !!sourceNode.points;
        var targetIsEdge = !!targetNode.points;
        var sourceIsBiopaxPhysicalEntity = gpml_utilities_1.intersectsLSV(biopaxPhysicalEntityTypesPrefixed, sourceNode.type);
        var targetIsBiopaxPhysicalEntity = gpml_utilities_1.intersectsLSV(biopaxPhysicalEntityTypesPrefixed, targetNode.type);
        var sourceIsBiopaxPhysicalEntityOrPathway = sourceIsBiopaxPhysicalEntity ||
            gpml_utilities_1.intersectsLSV('Pathway', sourceNode.type);
        var targetIsBiopaxPhysicalEntityOrPathway = targetIsBiopaxPhysicalEntity ||
            gpml_utilities_1.intersectsLSV('Pathway', targetNode.type);
        //*
        if (sourceIsBiopaxPhysicalEntity && targetIsBiopaxPhysicalEntity) {
            // TODO is this a safe assumption? The resulting JSON will have a BioPAX
            // type of Conversion, which is a superclass for the closest BioPAX terms
            // to mim-cleavage and mim-binding.
            // The plain arrow could also theoretically represent mim-transcription-translation,
            // but our pathways use DataNodes of type GeneProduct to cover that. They don't
            // usually indicate Gene -> RNA -> Protein
            marker = 'mim-conversion';
        }
        else if ((sourceIsEdge && targetIsBiopaxPhysicalEntityOrPathway) ||
            (sourceIsBiopaxPhysicalEntityOrPathway && targetIsEdge)) {
            // TODO is this a safe assumption? It's unreasonable for it to be an inhibition.
            // If it's actually supposed to be a mim-catalysis or mim-necessary-stimulation
            // instead of a mim-stimulation, the resulting JSON will still not be exactly wrong,
            // because both mim-stimulation and mim-necessary-stimulation are mapped to
            // a BioPAX Control w/ controlType ACTIVATION, and Control is a superclass
            // of Catalysis.
            marker = 'mim-stimulation';
        }
    }
    var identifierMappings = markerNameToIdentifierMappings[marker];
    var biopaxType;
    if (!!identifierMappings) {
        var biopaxMappings = identifierMappings.biopax;
        if (!!biopaxMappings && !!biopaxMappings.name) {
            biopaxType = interaction.biopaxType = 'biopax:' + biopaxMappings.name;
            var biopaxControlType = biopaxMappings.controlType;
            if (biopaxControlType) {
                interaction.biopaxControlType = biopaxControlType;
            }
        }
        var wpInteractionType = identifierMappings.wp;
        if (!!wpInteractionType) {
            interaction.wpInteractionType = wpInteractionType;
        }
        var sboInteractionType = identifierMappings.sbo;
        if (!!sboInteractionType) {
            interaction.sboInteractionType = sboInteractionType;
        }
        interaction.type = gpml_utilities_1.unionLSV(interaction.type, biopaxType, wpInteractionType, sboInteractionType);
    }
    /* this below is an attempt to model interactions using named graphs
    interaction.relationGraph = [{
        id: sourceId,
        relation: targetId
    }];
    //*/
    // and this is an attempt to model interactions using Biopax
    // TODO still need to consider things like CovalentBindingFeature, etc.
    if (gpml_utilities_1.intersectsLSV(['biopax:Interaction', 'biopax:MolecularInteraction'], biopaxType)) {
        interaction.participant = [];
        interaction.participant.push(sourceId);
        interaction.participant.push(targetId);
    }
    else if (gpml_utilities_1.intersectsLSV(['biopax:Control', 'biopax:Catalysis'], biopaxType)) {
        if (!!identifierMappings && !!identifierMappings.controlType) {
            interaction.controlType = identifierMappings.controlType;
        }
        interaction.controller = sourceId;
        interaction.controlled = targetId;
    }
    else if (gpml_utilities_1.intersectsLSV(['biopax:Conversion', 'biopax:BiochemicalReaction', 'biopax:Degradation'], biopaxType)) {
        // TODO this isn't actually checking the other marker to
        // make sure it also indicates conversion
        if (!!interaction.markerStart && !!interaction.markerEnd) {
            interaction.conversionDirection = 'REVERSIBLE';
        }
        else {
            interaction.conversionDirection = 'LEFT-TO-RIGHT';
        }
        interaction.left = sourceId;
        interaction.right = targetId;
    }
    else {
        interaction.participant = [];
        interaction.participant.push(sourceId);
        interaction.participant.push(targetId);
    }
    /*
    if (marker === 'mim-binding' || marker === 'mim-covalent-bond') {
        // TODO something with entityFeature, BindingFeature, CovalentBindingFeature, bindsTo...
    }
    //*/
    if (gpml_utilities_1.intersectsLSV(interaction.type, 'biopax:Catalysis')) {
        var controlled = elementMap[interaction.controlled];
        var controller = elementMap[interaction.controller];
        if (!gpml_utilities_1.intersectsLSV(biopaxNodeTypesPrefixed, controller.type)) {
            // If the controller is not a Pathway or PhysicalEntity,
            // we make this interaction generic, because it's not a valid
            // Catalysis.
            var controllerType = controller.type;
            if (gpml_utilities_1.intersectsLSV(controllerType, 'Group')) {
                controller.type = gpml_utilities_1.unionLSV(controllerType, 'Complex');
            }
            else {
                convertCatalysisToGenericInteraction(interaction);
            }
        }
        // If it's still a Catalysis, we need to make the controlled be a Conversion.
        if (gpml_utilities_1.intersectsLSV('biopax:Catalysis', interaction.type) &&
            gpml_utilities_1.intersectsLSV('biopax:Interaction', controlled.type)) {
            controlled.type = gpml_utilities_1.unionLSV(controlled.type, 'biopax:Conversion');
            var participants = controlled.participant;
            if (lodash_1.isArray(participants) && participants.length >= 2) {
                controlled.left = participants[0];
                controlled.right = participants[1];
                delete controlled.participant;
            }
            else {
                convertConversionToGenericInteraction(controlled);
                convertCatalysisToGenericInteraction(interaction);
            }
        }
    }
    return interaction;
}
exports.postProcess = postProcess;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/interaction.js
// module id = 131
// module chunks = 0